<template>
   <div id="ContainerContact">
      <div class="row page-height">
         <div class="col-12">
          <MdTitleRegInfo
              v-bind:RegistrationInfo="PatientTitle" 
              v-bind:titlePrefix="title" 
              v-bind:titleRef="'titleElementAppoEditor'"
              v-bind:patientCode="this.$route.params.id">
            </MdTitleRegInfo>
         </div>
      </div>
      <b-row>
        <b-col md="6" lg="6" sm="12">
          <MdSelect
            v-bind:Label="'Resource'"
            v-bind:Options="TherapistList"
            v-bind:ModelArray="TherapistVmodel"
            v-bind:FieldDescription="'employeeName'"
            v-bind:FieldCode="'employeeCode'"
            v-bind:Placeholder="selectPlaceholder"
            v-bind:Multiple="false"
            v-bind:isRequired="true"
            v-bind:isValid="this.isValidResource"
            :Input="ChangeDropDownTherapist"/> 
        </b-col>
        <b-col md="6" lg="6" sm="12">
          <MdEdit 
            v-bind:Label="$t('MdCurrentAppointment.StarTime')"
            v-bind:TypeProp="'datetime-local'" 
            v-bind:Name="'startTime'"
            v-bind:Min="'1900-01-01'"
            v-bind:Max="'2200-12-31'"
            v-model="startTime"
            v-on:blur="changeStartTime"/>                                     
        </b-col>
      </b-row>
      <b-row v-if="this.AppoinmentTypeList && this.AppoinmentTypeList.length > 1">
        <b-col md="6" lg="6" sm="12">
          <MdSelect
            v-bind:Label="$tc('Shared.AppointmentType')"
            v-bind:Options="AppoinmentTypeList"
            v-bind:ModelArray="AppoinmentTypeVmodel"
            v-bind:FieldDescription="'description'"
            v-bind:FieldCode="'code'"
            v-bind:Placeholder="selectPlaceholder"
            v-bind:Multiple="false"
            v-bind:isRequired="true"
            v-bind:isValid="this.isValidAppointmentType"
            :Input="ChangeDropDownAppoinmentType"/>
        </b-col>
      </b-row>

    <div class="space-actions"></div>
      <div class="page-actions">
        <MdButton
          v-bind:Label="$t('Shared.Save')"
          v-bind:ClassProp="'primary btn-login mx-2'"
          v-on:click="Save"
          v-bind:Name="'btn_save_appointment'"
        />
      </div>
   </div>
</template>

<script>
const momentTZ = require('moment-timezone');
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import AppoinmentTypeService from '@/services/appointmenttypes.service'
import CalendarResourcesService from '@/services/calendarresources.service'
import DBFunctions from '@/common/DBFunctions.js'
import SchedulerService from '@/services/schedulers.service'
import GlobalService from '@/services/global.service'
import EnumService from "@/services/enum.service";
import Permission from '@/common/Permission'

export default {

  beforeRouteLeave(to, from, next) {
	if (this.pendingChanges) {
		this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$tc('ENUM.PITEMS.PRESCREENING'),
          okTitle: this.$t('Shared.BtnSave'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){
              next();
            } else {
              this.Save();
              next();
            }
          })		
	} else {
		next()
	}
    },

   mixins: [ShowMessage, DBFunctions, Permission],
   name: 'PreScreeningEditor',
    data() {
      return {
        PatientTitle:{      
          programName:'',
          fullName:'',
          admitDate:'',
          dischargeDate:'',
          dob:'',
          activitytypename:'',
          startdatetime:'',
          ageFormatted:'',
          appointmentType: '',
        },
        fullParam: {
            PageSize:0,
            PageNumber:0
        },
        patientCode: '',
        patientName: '',
        subject: '',
        startDateTime: '',
        AppoinmentTypeList:  [],
        TherapistList:[],
        AppoinmentTypeVmodel: {},
        TherapistVmodel: {},
        selectPlaceholder: this.$t('Shared.SelectOptions'),
        startTime: null,
        endTime: null,
        AuxFields: ["lastname", "cellPhone", "dayPhone", "nightPhone"],
        phone: null,
        pendingChanges: false,
        title: 'PreScreening',
        prepareData: {
          StartDate: null,
          EndDate: null,
          action: '',
          key: '',
          added: {},
          changed: {},
          deleted: {}
        },
        timezone:'',
        OptionsRightMenu:{
          visible:true,
          ItemsList:[],
          btnvisible:true,
          itemdisabled: false,
        },
        locale: localStorage.language,
        infoList: null,
        isValidResource: true,
        isValidAppointmentType: true
      }
    },

    methods:{

      ChangeDropDownAppointmentLocation(options) {
        this.AppointmentLocationVmodel = options;
        this.LocationSelected = options && options.code ? options.code : null;
      },

      async getTimeZone() { 
         await GlobalService.getTimeZone()
            .then((response) => {      
               if (response.data) {
                this.timezone = response.data.id
               }  
            })
            .catch(error => {
             this.showResponseErrorMessage(error);
            });   
      },

      setPrepareData() {
        let startDateWithZone =  momentTZ.tz(Utils.formatterDate(this.startTime)+'T00:00:00', this.timezone)
        let endDateWithZone = momentTZ.tz(Utils.formatterDate(this.endTime)+'T00:00:00', this.timezone)

        this.prepareData = {
          StartDate: startDateWithZone.toISOString(),
          EndDate:  endDateWithZone.toISOString(),
          action: 'insert',
          added: this.getData(),
          changed: [],
          deleted: []
        }
      },

      getData() {
        let data = [{
          Id: '',
          StartTime: momentTZ.tz(this.startTime, this.timezone),
          EndTime: momentTZ.tz(this.endTime, this.timezone),
          Subject: this.subject,
          Type: this.AppoinmentTypeVmodel && this.AppoinmentTypeVmodel.code ? this.AppoinmentTypeVmodel.code : null,
          employeeCode: this.TherapistVmodel && this.TherapistVmodel.employeeCode ? this.TherapistVmodel.employeeCode : null,
          patientCode: this.patientCode,
          PatientName: this.patientName,
          Groupcreationid: 'WaitingList',
          Status: 'SCHEDULER',
          PatientShowedUp: true
        }]
        return data
      },

      validation() {
        this.isValidResource = this.TherapistVmodel && this.TherapistVmodel.employeeCode && this.TherapistVmodel.employeeCode.length > 0 ? true : false;
        this.isValidAppointmentType = this.AppoinmentTypeVmodel && this.AppoinmentTypeVmodel.code && this.AppoinmentTypeVmodel.code.length > 0 ? true : false;
        return this.isValidResource && this.isValidAppointmentType
      },

      async Save() {
        this.pendingChanges = false;
        if (this.validation()) {
          this.setPrepareData()
      
          await SchedulerService.schedulerUpdAdd(this.prepareData)
            .then((response) => {
              if(response.status == '200'){
                let insertResponse = response.data
                this.$router.push({ name: "appointment-patientdb-notes", params: { id: this.$route.params.id, actId:insertResponse[0].activityid } });
              } 
            })
            .catch((error) => {
              this.Load = false;
              this.showResponseErrorMessage(error);
            });
        }
      },

      getPhoneNumber(cellPhone, dayPhone, nightPhone) {
        if (cellPhone) return cellPhone;
        if (dayPhone) return dayPhone;
        if (nightPhone) return nightPhone;
        return "";
      },

      setValid(value) {
        this.classValue = value ? "form-control" : "form-control is-invalid";
      },

      loadPatient() {
        let patientObject = {}
        
        patientObject.code = this.infoList[0].patientcode
        patientObject.description = this.infoList[0].firstname
        patientObject.AuxFields = []
        patientObject.AuxFields.push(this.infoList[0].lastname)
        patientObject.AuxFields.push(this.infoList[0].cellPhone)
        patientObject.AuxFields.push(this.infoList[0].dayPhone)
        patientObject.AuxFields.push(this.infoList[0].nightPhone)

        this.patientCode = patientObject.code;
        this.phone = patientObject.AuxFields && this.getPhoneNumber(patientObject.AuxFields[1],patientObject.AuxFields[2],patientObject.AuxFields[3])
        this.patientName = `${patientObject.description} ${patientObject.AuxFields && patientObject.AuxFields[0] ? patientObject.AuxFields[0] : ''}`
        this.subject = `${this.patientName} ${this.phone}`

        this.PatientTitle.fullName  = `${patientObject.description} ${patientObject.AuxFields && patientObject.AuxFields[0] ? patientObject.AuxFields[0] : ''}`
        const { dob, age, ageFormatted } = this.infoList[0];

        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age;
      },

      changeStartTime() {
        let AppTypeDuration = 15

        this.startDateTime = this.PatientTitle.startdatetime = Utils.formatterDateTimeToString(this.startTime)
        
        if(this.AppoinmentTypeVmodel.duration)
          AppTypeDuration = this.AppoinmentTypeVmodel.duration
        
        let startTimeObj = new Date(this.startTime)
        let endTimeObj = new Date(startTimeObj.getTime() + AppTypeDuration*60000)
        this.endTime = Utils.formatDateTime(endTimeObj)
      },

      setEndTime(astartTime,duration) {
        let startTimeObj = new Date(astartTime)
        let endTimeObj = new Date(startTimeObj.getTime() + duration*60000)
        return Utils.formatDateTime(endTimeObj)
      },

      ChangeDropDownAppoinmentType(appttypes){
        this.AppoinmentTypeVmodel = appttypes;
        this.isValidAppointmentType = appttypes && appttypes.code && appttypes.code.length > 0 ? true : false;
        this.nameAppointmentType = this.PatientTitle.appointmentType = appttypes.description

        let duration = appttypes.duration;

        this.startTime = Utils.formatterToISO(new Date(),Utils.getSchedulerDateTimeFormat())                          

        this.endTime = this.setEndTime(this.startTime,duration) 
      },

      ChangeDropDownTherapist(therapists){
        this.TherapistVmodel = therapists;
        this.isValidResource = this.TherapistVmodel && this.TherapistVmodel.employeeCode && this.TherapistVmodel.employeeCode.length > 0 ? true : false;
      },

      async getAppointmentTypes() { 
        await AppoinmentTypeService.getPreScreening()
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.AppoinmentTypeList = response.data;
                if (this.AppoinmentTypeList.length == 1) {
                  this.AppoinmentTypeVmodel = this.AppoinmentTypeList[0]
                }
              }
            })
            .catch(error => {
             this.showResponseErrorMessage(error);
            });
      },

      async getEmployees() { 
        await CalendarResourcesService.getAll(this.fullParam)
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.TherapistList = response.data;
              }
            })
            .catch(error => {
             this.showResponseErrorMessage(error);
            });
        },

      async PopulatePatientTitle(patientCode) {
        this.infoList = await this.getInfoTitle(patientCode ? patientCode : this.$route.params.id);
        if(this.infoList.length > 0){
          this.PatientTitle.programName = '';
          this.PatientTitle.admitDate = '';
          this.PatientTitle.dischargeDate = '';
          const { dob, age, ageFormatted } = this.infoList[0]; // Destructure for easier access

          if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
          if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
          if (age) this.PatientTitle.age = age;
          this.PatientTitle.fullName = this.patientName;     
        }
      },

      beforeWindowUnload(e) {
        if (this.pendingChanges) {
          e.preventDefault()
          e.returnValue = ''	
        }
      },
    },

    async mounted(){
        this.OptionsRightMenu.visible = this.$route.name == 'appointmentDB-Editor-Add' ? false : true;    
        this.OptionsRightMenu.btnvisible = this.$route.name == 'appointmentDB-Editor-Add' ? false : true;
        this.OptionsRightMenu.itemdisabled = false;
        this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);

        await this.PopulatePatientTitle()
        this.loadPatient()
    },

    async created () {
        await this.getEmployees()
        await this.getAppointmentTypes()
        await this.getTimeZone()

        this.startTime = Utils.formatterToISO(new Date(),'YYYY-MM-DD[T]HH:mm')
        this.changeStartTime()

        EventBus.$on("onChanged", function (e) { 
            this.pendingChanges = e.Changed;
        }.bind(this));
    },

    destroyed(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        EventBus.$off('onChanged');
    }
  } 
</script>


